import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const QUOTATYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.QuotaType.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.QuotaType.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const QUOTATYPE_CONFIG = {
  entityName: 'QuotaType',
  localizationKey: 'Controlling::Entity.QuotaType',
  fields: QUOTATYPE_FIELDS,
  permission: 'ControllingLiquidations.QuotaTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
